import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppSeoProvider from "./AppSeoProvider";
import Index from "./pages/Index";
import PageAbout from "./pages/PageAbout";
import PageArchives from "./pages/PageArchives";
import PageArticleDetail from "./pages/PageArticleDetail";
import PageArticles from "./pages/PageArticles";
import PageChantsDesperanceCollectionGroupedGrid from "./pages/PageChantsDesperanceCollectionGroupedGrid";
import PageChantsSectionsGrid from "./pages/PageChantsSectionsGrid";
import PageContact from "./pages/PageContact";
import PageEvents from "./pages/PageEvents";
import PageIndexGarizimRiveSud from "./pages/PageIndexGarizimRiveSud";
import PageNotFound from "./pages/PageNotFound";
import PagePrivacyPolicy from "./pages/PagePrivacyPolicy";
import PageServices from "./pages/PageServices";
import PageSongDetail from "./pages/PageSongDetail";
import PageTermsOfService from "./pages/PageTermsOfService";

export interface INavigation {
  id: string;
  name: string;
  href: string;
  categories: number[];
  active?: boolean;
}

export const Navigations: INavigation[] = [
  { id: "home", name: "MTL", href: "/", categories: [0] },
  {
    id: "garizim-rive-sud",
    name: "RIVE SUD",
    href: "/garizim-rive-sud",
    categories: [0],
  },
  { id: "services", name: "SERVICES", href: "/services", categories: [0] },
  {
    id: "chants-desperance",
    name: "CHANT D'ESPÉRANCE",
    href: "/chants-desperance",
    categories: [0],
  },
  { id: "articles", name: "ARTICLES", href: "/articles", categories: [0] },
  { id: "events", name: "ÉVÈNEMENTS", href: "/events", categories: [0] },
  { id: "contact", name: "CONTACT", href: "/contact", categories: [0] },
];

export const AppRoutes = () => (
  <BrowserRouter>
    <AppSeoProvider />
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/2024/08/06/mot-de-bienvenue" element={<Index />} />

      {/* Legal & Compliance Routes (AdSense) */}
      <Route
        path="/politique-de-confidentialite"
        element={<PagePrivacyPolicy />}
      />
      <Route path="/privacy-policy-2" element={<PagePrivacyPolicy />} />
      <Route path="/privacy-policy" element={<PagePrivacyPolicy />} />
      <Route
        path="/conditions-utilisation"
        element={<PageTermsOfService />}
      />
      <Route
        path="/conditions-d-utilisation"
        element={<PageTermsOfService />}
      />
      <Route path="/terms" element={<PageTermsOfService />} />

      {/* Institutional Transparency Routes */}
      <Route path="/a-propos" element={<PageAbout />} />
      <Route path="/about" element={<PageAbout />} />

      {/* Church Community & Services */}
      <Route path="/services" element={<PageServices />} />
      <Route path="/garizim-rive-sud" element={<PageIndexGarizimRiveSud />} />
      <Route path="/contact" element={<PageContact />} />
      <Route path="/contact-nous" element={<PageContact />} />
      <Route path="/archives-videos" element={<PageArchives />} />
      <Route path="/archives" element={<PageArchives />} />
      <Route path="/events" element={<PageEvents />} />

      {/* Editorial Content / Articles & Reflections */}
      <Route path="/articles" element={<PageArticles />} />
      <Route path="/articles/:slug" element={<PageArticleDetail />} />
      <Route path="/blog" element={<PageArticles />} />
      <Route path="/reflexions" element={<PageArticles />} />

      {/* Chants d'Espérance */}
      <Route
        path="/chants-desperance"
        element={<PageChantsDesperanceCollectionGroupedGrid />}
      />
      <Route
        path="/chants-desperance/:sectionCode"
        element={<PageChantsSectionsGrid />}
      />
      <Route
        path="/chants-desperance/:sectionCode/:number"
        element={<PageSongDetail />}
      />
      <Route
        path="/chant-desperance"
        element={<PageChantsDesperanceCollectionGroupedGrid />}
      />
      <Route
        path="/chant-desperance/:sectionCode"
        element={<PageChantsSectionsGrid />}
      />
      <Route
        path="/chant-desperance/:sectionCode/:number"
        element={<PageSongDetail />}
      />
      <Route
        path="/chants"
        element={<PageChantsDesperanceCollectionGroupedGrid />}
      />
      <Route
        path="/hymns"
        element={<PageChantsDesperanceCollectionGroupedGrid />}
      />

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  </BrowserRouter>
);
